import { GqlQueryFactory } from '@skand/graphql-tools';
import { toast } from '@skand/ui';
import { createStore } from 'jotai';

export type JotaiStore = ReturnType<typeof createStore>;
export type ToastFn = typeof toast;

export class DownloadContext {
  readonly gqlQueryFactory: GqlQueryFactory;
  readonly jotaiStore: JotaiStore;
  readonly toastFn: ToastFn;

  constructor(args: {
    gqlQueryFactory: GqlQueryFactory;
    jotaiStore: JotaiStore;
    toastFn: ToastFn;
  }) {
    this.gqlQueryFactory = args.gqlQueryFactory;
    this.jotaiStore = args.jotaiStore;
    this.toastFn = args.toastFn;
  }
}
